'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _reactRouter = require('react-router');

var _components = require('../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header() {
  return _react2.default.createElement(
    'header',
    { className: 'Header' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        _reactRouter.IndexLink,
        { to: '/', className: 'logo' },
        _react2.default.createElement('img', { src: '/logo.png', alt: _config2.default.app.title })
      ),
      _react2.default.createElement(_components.Menu, null)
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.js
// module id = 1168
// module chunks = 0